import { FC } from 'react'
import DownloadBlankPreviewFiles from '../../../../../components/buttons/download-blank-preview-files/download-blank-preview-files'
import Task from '../../../../../types/api/task'

interface BlankPreviewFileProps {
    task: Task
}

const BlankPreviewFile: FC<BlankPreviewFileProps> = ({ task }) => {
    const shipment = task.shipment
    if (!shipment?.documentId) return null

    return (
        <DownloadBlankPreviewFiles
            shipmentDocumentId={shipment.documentId}
            blankPreviewFiles={shipment.blankPreviewFiles}
        />
    )
}

export default BlankPreviewFile
